//import { sleepMs } from 'src/misc/Misc';
import { handleResponse, getAccessHeaders } from './common';
import { ENV } from 'src/misc/Config';

export const getMyNotifications = async () => {
  const headers = await getAccessHeaders();
  return handleResponse(
    await fetch(`${ENV.apiUrl}/notifications/my`, {
      method: 'GET',
      headers: { ...headers, 'Content-Type': 'application/json' },
    })
  );
};

export const getNotifications = async (userId) => {
  console.log('getNotifications for userId', userId);
  const headers = await getAccessHeaders();
  return handleResponse(
    await fetch(`${ENV.apiUrl}/notifications/users/${userId}`, {
      method: 'GET',
      headers: { ...headers, 'Content-Type': 'application/json' },
    })
  );
};

export const markAsRead = async (notificationId) => {
  const headers = await getAccessHeaders();
  return handleResponse(
    await fetch(`${ENV.apiUrl}/notifications/${notificationId}`, {
      method: 'PATCH',
      headers: { ...headers, 'Content-Type': 'application/json' },
      body: JSON.stringify({
        is_read: true,
      }),
    })
  );
};

export const markAsReadAll = async (userId) => {
  const headers = await getAccessHeaders();
  return handleResponse(
    await fetch(`${ENV.apiUrl}/notifications/users/${userId}/markasread`, {
      method: 'POST',
      headers: { ...headers, 'Content-Type': 'application/json' },
    })
  );
};

export const markAsReadByMessageId = async (userId, messageId) => {
  const headers = await getAccessHeaders();
  return handleResponse(
    await fetch(`${ENV.apiUrl}/notifications/users/${userId}/${messageId}/markasread`, {
      method: 'PATCH',
      headers: { ...headers, 'Content-Type': 'application/json' },
      body: JSON.stringify({
        is_read: true,
      }),
    })
  );
};

export const deleteAllByUserId = async (userId) => {
  const headers = await getAccessHeaders();
  return handleResponse(
    await fetch(`${ENV.apiUrl}/notifications/users/${userId}`, {
      method: 'DELETE',
      headers: { ...headers, 'Content-Type': 'application/json' },
      body: JSON.stringify({
        is_read: true,
      }),
    })
  );
};
